import { type Editor as TipTapEditor } from '@tiptap/react'
import React, { useRef } from 'react'

import { Editor, MenuBar } from 'components/reusable/Notes'

type NoteEditorProps = {
  setValue: (value: string) => void
}

const NoteEditor = ({ setValue }: NoteEditorProps) => {
  const editorRef = useRef<TipTapEditor>()

  return (
    <div className='flex flex-col border rounded-lg bg-gray-100 gap-2'>
      <MenuBar editor={editorRef.current} />
      <Editor
        onEditorCreate={(editor) => {
          editorRef.current = editor
        }}
        onEditorUpdate={(editor) => {
          setValue(editor.getHTML())
        }}
        onEditorEmptyChange={(isEmpty) => {
          if (isEmpty) {
            setValue('')
          }
        }}
        className='min-h-20 px-2 pb-2 outline-none'
      />
    </div>
  )
}

export default NoteEditor
